var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.11 52.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.46l5.92 6.79c14.71-16.88 38.56-16.88 53.27 0l5.9-6.79C47.15-5.15 18-5.15 0 15.46zm23.68 27.13l8.88 10.19 8.87-10.19a11.43 11.43 0 0 0-17.75 0zM11.84 29.04l5.92 6.79c8.17-9.37 21.42-9.37 29.59 0l5.92-6.79c-11.42-13.11-29.98-13.11-41.43 0z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/WIFI.134f3b73.svg";
export { ForwardRef as ReactComponent };